import React, { useEffect, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.scss";
import BannerSlider from "../commonComponents/BannerSlider";
import CommonSlider from "../commonComponents/CommonSlider";
import config, { getHeaders } from "../config";
import { reactLocalStorage } from "reactjs-localstorage";
import Modal from "react-modal";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import _ from "lodash";
import { logEventHome } from "../Analytics/AnalyticsEvent";
import { screen } from "../Analytics/EventName";
import Loader from "../commonComponents/Loader";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
  },
};

Modal.setAppElement("#root");

function Home({
  games,
  banners,
  view_btn_txt,
  view_btn_color,
  view_all,
  play_btn_txt,
  flow,
  sub_url,
}) {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [heMsg, setHeMsg] = useState("");
  const [loading, setLoading] = useState(true);
  let history = useHistory();
  let location = useLocation();
  let params = queryString.parse(location.search);
  console.log("params >>>>>>>>>", params);
  let { search } = useLocation();
  const { uid,rcid,camp } = queryString.parse(search);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
  };

  useEffect(() => {
    // let url = window.location.href
    // url = url.replace('#/', '');
    // let keyArr = url.split('?')[1]
    // let uid = keyArr && keyArr.split("=")[1]
    const handleCheckUser=async()=>
    {
    console.log("uid", uid);
    if (uid !== "" && uid !== undefined) {
      reactLocalStorage.set("uid", uid);
      await checksub(uid);
    } else {
      if (
        reactLocalStorage.get("uid") !== "" &&
        reactLocalStorage.get("uid") !== undefined
      ) {
        await checksub(reactLocalStorage.get("uid"));
      } else {
        if (!flow || flow === "home") {
            appConfig()
        }
         else {
          setLoading(false);
        }
      }
    }
  }
  handleCheckUser()
  }, []);

  function capatalize(title) {
    return title.charAt(0).toUpperCase() + title.slice(1) + " Games";
  }
 const appConfig=async ()=>
 {
      try{
        const url = `${config.get("base")}${config.get("appConfig")}`;
         const  response =await fetch(url, {
            method: "POST",
            body: JSON.stringify({
              mcc: "652",
              mnc: "04",
              uid: reactLocalStorage.get("uid")
                ? reactLocalStorage.get("uid")
                : "",
            }),
            headers: getHeaders(),
          })
           const result=await response.json();
           logEventHome(
                  {
                    screen: screen.homePage,
                    event: "Redirected to" + result.sub_url,
                  },
                  {}
                );
               let redirect_url=sub_url+'?sid='+localStorage.getItem("sessionId")
                const rc_id = localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || rcid;
                const camp_id = localStorage.getItem("camp")  || sessionStorage.getItem("camp") || camp;
                if (rc_id) {
                redirect_url += '&rcid=' + rc_id;
                }
                if (camp_id) {
                redirect_url += '&camp=' + camp_id;
                }
                console.log("redirect_url::",redirect_url)
                window.open(redirect_url, "_self")   
        }catch(err)
        {
            console.log("Api failed to fetch",err)
        }
 }
  const checksub = async (uid) => {
    try {
      setLoading(true);
      const url = `${config.get('base')}${config.get('checkSub')}`
      const response = await fetch(url, {
        method: "POST",
        body: JSON.stringify({ uid: uid }),
        headers: getHeaders(),
      });

      if (!response.ok) {
        console.log("API request failed with status:", response.status);
        return;
      }
      const result = await response.json();
      reactLocalStorage.set("subStatus", result.subStatus);
      reactLocalStorage.set("status_display", result.status_display);
      reactLocalStorage.set("showUnsub", result.showUnsub);
      reactLocalStorage.set("msisdn", result.msisdn);
      reactLocalStorage.set("unsubtext", result.unsub_msg_txt);
      reactLocalStorage.set("status", result.status);
      logEventHome(
        {
          screen: screen.homePage,
          event: "checksub_api_success",
        },
        {
          others: {
            status: result.subStatus ? result.subStatus : "",
            uid: uid ? uid : "NA",
          },
        }
      );
      if (flow == "home" && result.subStatus !== "active") {
         let redirect_url=sub_url+'?sid='+localStorage.getItem("sessionId")
                const rc_id = localStorage.getItem("rcid") || sessionStorage.getItem("rcid") || rcid;
                const camp_id = localStorage.getItem("camp")  || sessionStorage.getItem("camp") || camp;
                if (rc_id) {
                redirect_url += '&rcid=' + rc_id;
                }
                if (camp_id) {
                redirect_url += '&camp=' + camp_id;
                }
                console.log("redirect_url::",redirect_url)
                window.open(redirect_url, "_self")   
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.error("Error checking sub:", error);
    }
  };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  function handleClick() {
    if (config.get("domain") === "btc") {
      window.location.reload();
    } else {
      history.push("/login");
    }
  }

  return (
    <>
      {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <div className="container m-w">
          <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div>{heMsg}</div>
            <button
              onClick={handleClick}
              style={{
                width: "23%",
                backgroundColor: "rgb(23 54 206)",
                color: "white",
                padding: "4% 1%",
                margin: "8px 0",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              Okay
            </button>
          </Modal>
          {banners && banners.length ? (
            <BannerSlider
              settings={{
                ...settings,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
              }}
              data={banners}
            />
          ) : (
            ""
          )}

          {games &&
            _.map(games).map((item, index) => (
              <CommonSlider
                settings={{
                  ...settings,
                  dots: false,
                  arrows: false,
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  centerPadding: "10%",
                  swipeToSlide: true,
                }}
                title={capatalize(item.title)}
                data={item.contents}
                key={index}
                category={item.title}
                btn_color={view_btn_color}
                view_all={view_all}
                play_btn_txt={play_btn_txt}
                screen="home"
              />
            ))}
        </div>
      )}
    </>
  );
}

export default Home;
